module.exports = __webpack_public_path__ + "img/1st.6c3448b.png";